<template>
  <el-dialog
    top="0"
    class="dialog-full-medium"
    width="70%"
    title="【先收后付】二次规则校验失败"
    append-to-body
    :visible.sync="visible"
    :close-on-click-modal="false"
    :before-close="handleClose"
    @open="handleOpen"
  >
    <div class="dialog__body">
      <div style="margin: 10px 0;">供应商付款申请金额大于实收金额，【先收后付】规则校验失败，不允许付款</div>
      <div class="main-cont">
        <div class="main-cont-item">
          <h2 class="title-text">供应商付款/补款记录</h2>
          <jr-table
            size="mini"
            :tableData="dataInfo.paymentApplyList || []"
            :tableColumn="tableColumn"
          >
            <template v-slot:orderNumber="{row}">
              <jr-tooltip
                :content="row.orderNumber"
                type="popover"
                :isFilter="true"
              />
            </template>
            <template v-slot:payAmountSlotName="{row}">
              <!-- tradeType: payment=付款, supplement=补款 -->
              <div :class="{'pay_amount_red':row.tradeType==='supplement'}">{{ row.payAmount | toFenThousandsAndFloat }}</div>
            </template>
          </jr-table>
        </div>
        <div class="main-cont-item">
          <h2 class="title-text">采购商收款/退款记录</h2>
          <jr-table
            size="mini"
            :tableData="dataInfo.receiptList || []"
            :tableColumn="tableColumn2"
          >
            <template v-slot:receiptAmountSlotName="{row}">
              <!-- tradeType: receipt=收款, refund=退款 -->
              <div :class="{'pay_amount_red':row.tradeType==='refund'}">{{ row.receiptAmount | toFenThousandsAndFloat }}</div>
            </template>
          </jr-table>
        </div>
      </div>
    </div>
    <span slot="footer">
      <el-button @click="handleClose()" :size="formSize" type="primary">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { setStatusColor } from '@/filters/index';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    dataInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      tableColumn: [
        { label: '申请编号', prop: 'payApplyNumber' },
        { label: '业务订单编号', prop: 'orderNumber', slotName: 'orderNumber' },
        { label: '付款/补款类型', prop: 'tradeTypeDesc' },
        { label: '付款/补款方式', prop: 'payModeDesc' },
        { label: '付款/补款渠道', prop: 'payWayDesc' },
        { label: '付款/补款金额(元)', prop: 'payAmount', filterName: 'toFenThousandsAndFloat', slotName: 'payAmountSlotName' },
        { label: '创建时间', prop: 'crtime', filterName: 'formatTime' },
        { label: '申请人', prop: 'cruser' },
        {
          prop: 'approvalStatus',
          label: '状态',
          status: 'approvalStatus',
          statusDesc: 'statusDesc',
          disabled: true,
          statusColor: (val) => setStatusColor(val, 'approvalStatus'),
        },
        { label: '操作人', prop: 'operatorName' },
      ],
      tableColumn2: [
        { label: '申请单号', prop: 'recApplyNo' },
        { label: '业务订单编号', prop: 'orderNumber' },
        { label: '收款/退款类型', prop: 'tradeTypeDesc' },
        { label: '收款/退款方式', prop: 'receiptTypeDesc' },
        { label: '收款/退款渠道', prop: 'receiptChannel' },
        { label: '收款/退款金额(元)', prop: 'receiptAmount', filterName: 'toFenThousandsAndFloat', slotName: 'receiptAmountSlotName' },
        { label: '创建时间', prop: 'crtime', filterName: 'formatTime' },
        { label: '申请人', prop: 'cruser' },
        {
          label: '状态',
          prop: 'verifiedStatus',
          status: 'verifiedStatus',
          statusDesc: 'verifiedStatusDesc',
          statusColor: (val) => setStatusColor(val, 'receiptStatus'),
        },
        { label: '操作人', prop: 'operatorName' },
      ],
    };
  },
  methods: {
    // 关闭
    handleClose() {
      this.$emit('update:visible', false);
    },
    // 打开窗口前
    handleOpen() {
      this.$nextTick(() => {
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.pay_amount_red {
  color: #f56c6c;
}
.dialog-full-medium {
  ::v-deep {
    .el-dialog {
      height: 80vh;
      overflow: auto !important;
      display: flex;
      flex-direction: column;
    }
    .el-dialog__body {
      flex: 1;
      overflow: hidden;
      width: 100%;
      height: 100%;
    }
    .dialog__body {
      height: 100%;
      width: 100%;
      overflow: auto;
      display: inline-block;
    }
  }
}
</style>
